import React, {useState} from 'react';
import Axios from 'axios';
import {Link} from 'react-router-dom';
import { useHistory, useParams } from "react-router-dom";



const Employee_edit = () =>{
   let history = useHistory();
   const { id } = useParams();
   const [user, setUser] = useState({
      name: "",
      lname: "",
      email: "",  
      phone: "",
      address: "",
      city: "",
      state: "",
      zip: "",
    });
  
    const { name, lname, email, phone, address, city, state, zip } = user;
    const onInputChange = e => {
      setUser({ ...user, [e.target.name]: e.target.value });
    };


    const onSubmit = async e => {
      e.preventDefault();
      await Axios.post("https://phpstack-181417-2015125.cloudwaysapps.com/api/employee/create", user);
      history.push("/employee_list");
    };


    const loadUser = async () => {
      const result = await Axios.get(`https://phpstack-181417-2015125.cloudwaysapps.com/api/employee/get/${id}`);
      setUser(result.data.data);
    };





    return (
<>
         <div id="content-page" className="content-page">
            <div className="container-fluid">
               <div className="row">
                  <div className="col-sm-12 col-lg-12">
                     <div className="iq-card">
                        <div className="iq-card-header d-flex justify-content-between">
                           <div className="iq-header-title">
                              <h4 className="card-title">Edit Employee</h4>
                           </div>
                        </div>
                        <div className="iq-card-body">
                          
                          
                        <form onSubmit={e => onSubmit(e)}>
                           
                          <div className="row">
                              <div className="form-group col-md-3">
                                 <label >First Name:</label>
                                 <input type="text" required placeholder="Add first Name" className="form-control" 
                                name="name"
                                value={name}
                                onChange={e => onInputChange(e)}
                                    
                                 />
                              </div>
                              <div className="form-group col-md-3">
                                 <label >Last Name:</label>
                                 <input type="text" required placeholder="Add Last Name"  className="form-control"  
                                 name="lname"
                                 value={lname}
                                 onChange={e => onInputChange(e)}                                  
                                 />
                              </div>
                              <div className="form-group col-md-3">
                                 <label >Email:</label>
                                 <input type="text" required placeholder="EX:abc@xyz.com"  className="form-control"  
                                 name="email"
                                 value={email}
                                 onChange={e => onInputChange(e)}
                                 />
                              </div>
                              <div className="form-group col-md-3">
                                 <label >Phone:</label>
                                 <input type="text" required className="form-control"  
                                    name="phone"
                                    value={phone}
                                    onChange={e => onInputChange(e)}
                                />
                              </div>

                              <div className="form-group col-md-3">
                                 <label >Address:</label>
                                 <input type="text" required className="form-control"  
                                    name="address"
                                    value={address}
                                    onChange={e => onInputChange(e)}
                                  />
                              </div>
                              <div className="form-group col-md-3">
                                 <label >City:</label>
                                 <input type="text" required className="form-control"  
                                  name="city"
                                  value={city}
                                  onChange={e => onInputChange(e)}
                                   
                                  />
                              </div>
                              <div className="form-group col-md-3">
                                 <label >State:</label>
                                 <input type="text" required className="form-control"   
                                  name="state"
                                  value={state}
                                  onChange={e => onInputChange(e)}
                                  />
                              </div>
                              <div className="form-group col-md-3">
                                 <label >Zip:</label>
                                 <input type="text" required max_length="6" placeholder="Ex:751006"  className="form-control"  
                                  name="zip"
                                  value={zip}
                                  onChange={e => onInputChange(e)}  
                                  />
                              </div> 

                              <div className="form-group  col-md-12">
                              <button type="submit"  className="btn btn-primary mr-2">Submit</button>

                              <Link  className="btn btn-info" to="/employee_list">Back to list</Link>
                              </div>
                               
                           </div>

                        </form>







                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>      
       
          
</>
    )
}

export default Employee_edit
